import React from 'react'
import CountdownNow from 'react-countdown-now'

export default class Countdown extends React.Component {
  countdownRenderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) return ''
    return (
      <time>
        <span aria-label="Days">{days}</span>
        <span aria-label="Hours">{hours}</span>
        <span aria-label="Mins">{minutes}</span>
        <span aria-label="Secs">{seconds}</span>
      </time>
    )
  }

  render() {
    const { date } = this.props

    if (!date || date <= new Date().getTime()) return <div />
    return (
      <div className="countdown">
        <CountdownNow date={date} renderer={this.countdownRenderer} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/partials/countdown.js